import user from './UserStore';
import media from './MediaStore';
import category from './CategoryStore';
import search from './SearchStore';

export default {
  user,
  category,
  media,
  search
};
